import { render, staticRenderFns } from "./MyCoursesNewContentToggle.vue?vue&type=template&id=3e061241&"
import script from "./MyCoursesNewContentToggle.vue?vue&type=script&lang=js&"
export * from "./MyCoursesNewContentToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/studip/studip/studip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e061241')) {
      api.createRecord('3e061241', component.options)
    } else {
      api.reload('3e061241', component.options)
    }
    module.hot.accept("./MyCoursesNewContentToggle.vue?vue&type=template&id=3e061241&", function () {
      api.rerender('3e061241', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/MyCoursesNewContentToggle.vue"
export default component.exports